import React from "react";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicSimplificationCFG = () => (
  <TOCModuleSubtopic
    title="Simplification of CFG – Elimination of Useless Symbols, Unit Productions, Null Productions"
    videos={[
      "https://www.youtube.com/embed/OHXVRAiOyeQ",
      "https://www.youtube.com/embed/R9Bz8rqPUmo",
      "https://www.youtube.com/embed/BLt4pJRBZdA",
      "https://www.youtube.com/embed/glVl5IGf8LI",
    ]}
    takeaways={[
      { text: "Practice a few problems on this (mostly direct questions will come)." },
    ]}
    questions={[
      {
        text: "Consider the following context-free grammar (CFG) G =({S, A, B, C, D, E}, (a, b, c, d, e}, P, S) where P is as follows. Apply the steps to simplify the CFG G by removing null and unit productions, then reduce the CFG by removing useless symbols.",
        image: "/image3.png",
      },
      {
        
        text: "Remove all unit productions, useless productions, and null productions from the grammar G=(V,T,P,S). What language does this grammar generate?",
        image: "/image4.png",
      },
    ]}
    exampleVideos={[]} // Add example question videos if needed
  />
);

export { ModuleSubtopicSimplificationCFG };
